import { render, staticRenderFns } from "./DetalhesProdutoPorLote.vue?vue&type=template&id=69b7fac8"
import script from "./DetalhesProdutoPorLote.vue?vue&type=script&setup=true&lang=js"
export * from "./DetalhesProdutoPorLote.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports